import { atomFamily } from 'jotai-family';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import type { NavigationScreenContentGapsState } from '@gitbook/app-navigation';

type ContentGapsListState = Pick<NavigationScreenContentGapsState, 'filters' | 'orderBy'>;

/** Last filters and ordering of a site's content gaps list, remembered for the tab's session. */
export const contentGapsListStateAtom = atomFamily((siteId: string) =>
    atomWithStorage<ContentGapsListState>(
        `contentGapsListState__${JSON.stringify(siteId)}`,
        {},
        createJSONStorage<ContentGapsListState>(() => sessionStorage),
        { getOnInit: true }
    )
);
